export default String.raw`
{% assign activeProduct = include -%}
{% assign imagesSize = activeProduct.ImagesExt | Size -%}
{% assign parentProduct = product-presentation.Product -%}
{% assign parentImagesSize = parentProduct.Images | Size -%}

{% if imagesSize > 0 -%}
    {% assign totalSize = imagesSize -%}
{% else -%}
    {% assign totalSize = parentImagesSize -%}
{% endif -%}

{% if product.YouTubeVideos[0] or indexesOfMp4VideosLength > 0 -%}
    {% assign youtubeVideosSize = product.YouTubeVideos | Size -%}
	{% if imagesSize > 0 -%}
        {% assign totalSize = imagesSize | Plus: youtubeVideosSize | Plus: indexesOfMp4VideosLength -%}
    {% else -%}
		{% assign totalSize = parentImagesSize | Plus: youtubeVideosSize | Plus: indexesOfMp4VideosLength -%}
    {% endif -%}
{% endif -%}

{% if totalSize > 0 -%}
    {% if imagesSize > 0 -%}
        {% for image in activeProduct.ImagesExt -%}
            <div class="swiper-slide {% if manyImages == false -%}zoom-btn-js" aria-label="{{ translations.ZoomImage }}" role="button"{% else -%}"{% endif -%} {% if isMulti or manyImages == false -%}tabindex="0"{% endif -%}>
                {% if image.Id -%}
                    {% if activeProduct.Id == product-presentation.Product.Id and image.Id != 0 -%}
                        {% for imageInParent in product-presentation.Product.Images -%}
                            {% if imageInParent.Id == image.Id -%}
                                <img alt="{{ image.Alt | H }}" src="{{ page.BaseHref }}img/{{ image.Id }}/{{ forloop.index }}.jpg" loading="eager" fetchpriority="high">
                                {% break -%}
                            {% endif -%}
                        {% endfor -%}
                    {% elseif image.Link == null && image.ExternalUrl != null -%}
                        <img alt="{{ image.Alt | H }}" src="{{ image.ExternalUrl }}" loading="eager" fetchpriority="high">
                    {% elseif image.Id != -1 -%}
                        <img alt="{{ image.Alt | H }}" src="{{ page.BaseHref }}img/{{ image.Id }}/{{ forloop.index }}.jpg" loading="eager" fetchpriority="high">
                    {% else -%}
                        <svg class="no-image">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
                        </svg>
                    {% endif -%}
                {% elseif image -%}
                    {% if image != -1 -%}
                        <img alt="{{ image.Alt | H }}" src="{{ page.BaseHref }}img/{{ image }}/{{ forloop.index }}.jpg" loading="eager" fetchpriority="high">
                    {% else -%}
                        <svg class="no-image">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
                        </svg>
                    {% endif -%}
                {% endif -%}
            </div>
        {% endfor -%}
    {% elseif parentImagesSize > 0 -%}
        {% for image in parentProduct.Images -%}
            <div class="swiper-slide {% if manyImages == false -%}zoom-btn-js" aria-label="{{ translations.ZoomImage }}" role="button"{% else -%}"{% endif -%} {% if isMulti or manyImages == false -%}tabindex="0"{% endif -%}>
                {% if image.Id -%}
                    {% if image.Link == null && image.ExternalUrl != null -%}
                        <img alt="{{ image.Alt | H }}" src="{{ image.ExternalUrl }}" loading="eager" fetchpriority="high">
                    {% else if image.Id != -1 -%}
                        <img alt="{{ image.Alt | H }}" src="{{ page.BaseHref }}img/{{ image.Id }}/{{ forloop.index }}.jpg" loading="eager" fetchpriority="high">
                    {% else -%}
                        <svg class="no-image">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
                        </svg>
                    {% endif -%}
                {% elseif image -%}
                    {% if image != -1 -%}
                        <img alt="{{ image.Alt | H }}" src="{{ page.BaseHref }}img/{{ image }}/{{ forloop.index }}.jpg" loading="lazy" >
                    {% else -%}
                        <svg class="no-image">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
                        </svg>
                    {% endif -%}
                {% endif -%}
            </div>
        {% endfor -%}
    {% endif -%}
{% else -%}
    <svg class="no-image">
        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
    </svg>
{% endif -%}
`